// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TatouageRouteImport } from './routes/tatouage'
import { Route as RendezVousRouteImport } from './routes/rendez-vous'
import { Route as PrixRouteImport } from './routes/prix'
import { Route as ModificationRouteImport } from './routes/modification'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TatouageIndexRouteImport } from './routes/tatouage/index'
import { Route as TatouageProjetRouteImport } from './routes/tatouage/projet'
import { Route as TatouageConfirmationRouteImport } from './routes/tatouage/confirmation'
import { Route as RendezVousIndexRouteImport } from './routes/rendez-vous/index'
import { Route as RendezVousConfirmationRouteImport } from './routes/rendez-vous/confirmation'

const TatouageRoute = TatouageRouteImport.update({
            id: '/tatouage',path: '/tatouage',getParentRoute: () => rootRouteImport
          })
const RendezVousRoute = RendezVousRouteImport.update({
            id: '/rendez-vous',path: '/rendez-vous',getParentRoute: () => rootRouteImport
          })
const PrixRoute = PrixRouteImport.update({
            id: '/prix',path: '/prix',getParentRoute: () => rootRouteImport
          })
const ModificationRoute = ModificationRouteImport.update({
            id: '/modification',path: '/modification',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TatouageIndexRoute = TatouageIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TatouageRoute
          })
const TatouageProjetRoute = TatouageProjetRouteImport.update({
            id: '/projet',path: '/projet',getParentRoute: () => TatouageRoute
          })
const TatouageConfirmationRoute = TatouageConfirmationRouteImport.update({
            id: '/confirmation',path: '/confirmation',getParentRoute: () => TatouageRoute
          })
const RendezVousIndexRoute = RendezVousIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RendezVousRoute
          })
const RendezVousConfirmationRoute = RendezVousConfirmationRouteImport.update({
            id: '/confirmation',path: '/confirmation',getParentRoute: () => RendezVousRoute
          })





const RendezVousRouteChildren = {
  RendezVousConfirmationRoute: RendezVousConfirmationRoute,RendezVousIndexRoute: RendezVousIndexRoute
}

const RendezVousRouteWithChildren = RendezVousRoute._addFileChildren(RendezVousRouteChildren)




const TatouageRouteChildren = {
  TatouageConfirmationRoute: TatouageConfirmationRoute,TatouageProjetRoute: TatouageProjetRoute,TatouageIndexRoute: TatouageIndexRoute
}

const TatouageRouteWithChildren = TatouageRoute._addFileChildren(TatouageRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ModificationRoute: ModificationRoute,PrixRoute: PrixRoute,RendezVousRoute: RendezVousRouteWithChildren,TatouageRoute: TatouageRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)